import API from './api';

const RegionalSettingsService = {
  getSystemDefaults() {
    // Get system locale
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    
    // Determine default date format based on locale
    let defaultDateFormat = 'DD/MM/YYYY';
    if (locale.includes('en-US')) {
      defaultDateFormat = 'MM/DD/YYYY';
    } else if (locale.includes('zh') || locale.includes('ja')) {
      defaultDateFormat = 'YYYY-MM-DD';
    }

    // Determine default time format based on locale
    const defaultTimeFormat = locale.includes('en-US') ? '12h' : '24h';

    return {
      useSystemDefaults: true,
      dateFormat: defaultDateFormat,
      timeFormat: defaultTimeFormat
    };
  },

  async getUserSettings() {
    try {
      const response = await API.get('regional-settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching regional settings:', error);
      // Return system defaults if there's an error
      return this.getSystemDefaults();
    }
  },

  async updateUserSettings(settings) {
    try {
      const response = await API.put('regional-settings', settings);
      // Update localStorage after successful update
      localStorage.setItem('regional-settings', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error('Error updating regional settings:', error);
      throw error;
    }
  },

  getStoredSettings() {
    const settings = localStorage.getItem('regional-settings');
    if (settings) {
      try {
        const parsedSettings = JSON.parse(settings);
        // If using system defaults, return current system defaults
        if (parsedSettings.useSystemDefaults) {
          return this.getSystemDefaults();
        }
        return parsedSettings;
      } catch (e) {
        console.error('Error parsing stored regional settings:', e);
      }
    }
    return this.getSystemDefaults();
  }
};

export default RegionalSettingsService; 